import { Component, Input, OnInit } from '@angular/core';
import { SurveyOpinionTaskStatusEnum } from '../../../models/surveys-tasks/enums/SurveyOpinionTaskStatusEnum';
import { Status } from '../../../models/surveys-tasks/SurveyTaskDetails';

@Component({
  selector: 'app-survey-tasks-status',
  standalone: false,
  templateUrl: './survey-tasks-status.component.html'
})
export class SurveyTasksStatusComponent implements OnInit {

  @Input({ required: true }) status: Status;
  @Input() isAmbassador = false;
  taskStatusEnum = SurveyOpinionTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }
}
